export const DRAW_OPTIONS_GLEBA = editableLayers => {
    return {
        position: 'topright',
        draw: {
            polygon: {
                allowIntersection: false,
                showArea: true,
                metric: ['ha'],
                drawError: {
                    color: '#e1e100',
                    message:
                        '<strong>As arestas do polígono não devem se cruzar</strong>'
                },
                shapeOptions: {
                    stroke: true,
                    color: '#F56600',
                    fillColor: '#F56600',
                    fillOpacity: 0.4,
                    opacity: 1,
                    weight: 2,
                    showMeasurements: false
                },
                icon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                }),
                touchIcon: new L.DivIcon({
                    iconSize: new L.Point(10, 10),
                    className:
                        'leaflet-div-icon leaflet-editing-icon leaflet-touch-icon'
                })
            },
            polyline: false,
            circle: false,
            rectangle: false,
            marker: false,
            circlemarker: false
        },
        edit: {
            featureGroup: editableLayers,
            edit: {
                selectedPathOptions: {
                    maintainColor: false,
                    dashArray: '2,4',
                    weight: 2,
                    color: '#F9BE04',
                    fillColor: '#F9BE04',
                    fillOpacity: 0.2,
                    opacity: 1
                }
            },
            remove: true,
            poly: {
                allowIntersection: false
            }
        }
    };
};
